export default "__VITE_ASSET__zN$__zg7__"